(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.directive('deliveryScoreTrendChartWidget', deliveryScoreTrendChartWidget);

	deliveryScoreTrendChartWidget.$inject = ['$filter', '$timeout', '$window', 'percentageFormatService', '$translate'];

	function deliveryScoreTrendChartWidget($filter, $timeout, $window, percentageFormatService, $translate) {
		return {
			restrict: 'A',
			scope: {
				monthlyValues: '=',
				threeMonthAvgValues: '=',
				monthlyRank: '='
			},
			link: function linkDeliveryScoreTrendChart(scope, element, attr) {
				var chart;
				var initListener;
				var w = angular.element($window);
				var windowHeight = 250;

				w.bind('resize', function () {
					if (chart) {
						chart.resize({ height: windowHeight });
					}
				});

				function init() {
					var gridLoaded = jQuery('#' + element[0].id).length;
					if (gridLoaded) {
						$timeout(function () {
							generateChart();
						}, 0);
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}

				function getMonths() {
					var firstMonth = new Date();
					var numMonths = scope.monthlyValues.length;
					firstMonth = new Date(firstMonth.getFullYear(), firstMonth.getMonth(), 1);
					firstMonth.setMonth(firstMonth.getMonth() - numMonths, 1);
					var months = [];
					for (var i = numMonths - 1; i >= 0; i--) {
						months.push($filter('date')(new Date(firstMonth), 'yyyy-MM-dd'));
						firstMonth.setMonth(firstMonth.getMonth() + 1, 1);
					}
					return months;
				}

				function getColorCode(d) {
					var colorCode = '#FF9B30';
					if (scope.monthlyRank[d.index]) {
						if (d.value || d.value === 0) {
							if (scope.monthlyRank[d.index] === 'good') {
								colorCode = '#37C074'; //Green
							} else if (scope.monthlyRank[d.index] === 'warning') {
								colorCode = '#FFE349'; //Yellow
							} else {
								colorCode = '#F42F2F'; //Red
							}
						}
					}

					return colorCode;
				}

				function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this;
					var config = $$.config;
					var CLASS = $$.CLASS;
					var titleFormat = config.tooltip_format_title || defaultTitleFormat;
					var valueFormat = config.tooltip_format_value || defaultValueFormat;
					var text, i, title, value, name;

					for (i = 0; i < d.length; i++) {
						if (!d[i] || !(d[i].value || d[i].value === 0)) {
							continue;
						}
						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = '<table class=\'' + CLASS.tooltip + '\'>';
							if (title || title === 0) {
								text += '<tr><th colspan=\'2\'>' + title + '</th></tr>';
							}
						}

						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						if (value !== undefined) {
							name = d[i].name;

							var colorCode = color(d[i].id);

							if (d[i] === 'delPerfMonthly' || d[i].id === 'delPerfMonthly') {
								colorCode = getColorCode(d[i]);
							}

							text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
							text += '<td class="name"><span style="background-color:' + colorCode + '"></span>' + name + '</td>';
							text += '<td class="value">' + value + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}

				function generateChart() {
					chart = c3.generate({
						bindto: '#' + element[0].id,
						data: {
							x: 'x',
							columns: [
								['x'].concat(getMonths()),
								['delPerfMonthly'].concat(scope.monthlyValues),
								['delPerfThreeMonthRollingAvg'].concat(scope.threeMonthAvgValues)
							],
							type: 'bar',
							types: {
								delPerfThreeMonthRollingAvg: 'line'
							},
							names: {
								'delPerfMonthly': $translate.instant('Monthly Performance'),
								'delPerfThreeMonthRollingAvg': $translate.instant('Rolling 3 Months Average')
							},
							color: function (color, d) {
								var colorCode = color;
								if (d === 'delPerfMonthly' || d.id === 'delPerfMonthly') {
									colorCode = getColorCode(d);
								}
								return colorCode;
							}
						},
						axis: {
							x: {
								type: 'timeseries',
								tick: {
									format: '%b %Y',
									count: 3
								}
							},
							y: {
								tick: {
									format: function (x) {
										return percentageFormatService.get(x);
									},
									count: 5
								},
								padding: {
									top: 0,
									bottom: 0
								},
								min: 0,
								max: 100,
								type: 'linear'
							}
						},
						size: {
							height: windowHeight,
							width: jQuery('#' + element[0].id).width()
						},
						point: {
							show: true,
							r: 2.5
						},
						line: {
							connectNull: true
						},
						padding: {
							top: 10,
							left: 50,
							right: 30,
							bottom: 10
						},
						legend: {
							show: false
						},
						tooltip: {
							contents: tooltipFormat
						},
						bar: {
							width: {
								ratio: 0.2
							}
						},
						grid: {
							y: {
								show: true
							}
						}
					});
					chart.legend.show('delPerfThreeMonthRollingAvg');
				}

				initListener = scope.$on('deliveryScoreTrendChartReady', function () {
					init();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (initListener) {
						initListener();
					}
					w.unbind('resize');
				});
			}
		};
	}
})();
